/**
 * Tabbed video gallery: switches panels, lazy-activates YouTube iframes on first open.
 */
if (!customElements.get('video-tabs')) {
  class VideoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index));
        tab.addEventListener('keydown', (e) => this.onTabKeydown(e, index));
      });

      const initial = this.panels.find((p) => p.classList.contains('is-active')) || this.panels[0];
      if (initial) this.activatePanelLazy(initial);
    }

    selectTab(index) {
      if (index < 0 || index >= this.tabs.length) return;

      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        const on = i === index;
        panel.toggleAttribute('hidden', !on);
        panel.classList.toggle('is-active', on);
        if (on) this.activatePanelLazy(panel);
      });
    }

    activatePanelLazy(panel) {
      panel.querySelectorAll('iframe[data-video-src]').forEach((frame) => {
        const src = frame.getAttribute('data-video-src');
        if (src && !frame.getAttribute('src')) {
          frame.setAttribute('src', src);
        }
      });
    }

    onTabKeydown(e, index) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        const next = Math.min(this.tabs.length - 1, index + 1);
        this.selectTab(next);
        this.tabs[next].focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = Math.max(0, index - 1);
        this.selectTab(prev);
        this.tabs[prev].focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        this.selectTab(0);
        this.tabs[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        const last = this.tabs.length - 1;
        this.selectTab(last);
        this.tabs[last].focus();
      }
    }
  }

  customElements.define('video-tabs', VideoTabs);
}
